import { createMicrophoneAndCameraTracks, createClient } from "agora-rtc-react";

const appId = "5bcc2afc17654b819edef2c2c7821e04";
const token = null;
export const channelName = "main"
export const config = { mode: "rtc", codec: "vp8", appId, token }
export const useClient = createClient(config);
export const useMicrophoneAndCameraTracks = createMicrophoneAndCameraTracks();